import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postCommentBookmark } from '../../../api/comments';

import { REQUEST } from '../../../constants/request';
import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const addCommentBookmark = createAsyncThunk(
  'comments/addCommentBookmark',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await postCommentBookmark(commentData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const commentCIDKey = generateCommentCIDKey(path);
      const { comments } = getState().comments;

      return (
        comments.comment.actions.bookmark.request[commentCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const addCommentBookmarkExtraReducers = builder => {
  builder
    .addCase(addCommentBookmark.pending, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.comments.comment.actions.bookmark.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(addCommentBookmark.fulfilled, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.comments.comment.actions.bookmark.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey].userdata = {
            ...state.comments.comment.byId[commentCIDKey].userdata,
            hasBookmarked: true,
          };
        },
      );
    })
    .addCase(addCommentBookmark.rejected, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.comments.comment.actions.bookmark.request[commentCIDKey],
        action,
      );
    });
};
